import { render, staticRenderFns } from "./TempCardShare.vue?vue&type=template&id=72a8d7bd&"
import script from "./TempCardShare.vue?vue&type=script&lang=js&"
export * from "./TempCardShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports